export function formatError(error: string) {
  // e.g. 'HttpError(404): 驗證碼不匹配'
  let match = error.match(/HttpError\(\d+\):\s+(.*)/)
  if (match) {
    return match[1]
  }
  return error
}
